<div
  class="sidebar"
  [ngClass]="{
    'sidebar-desktop-inactive': app.sidebarDesktopInactive,
    'sidebar-mobile-active': app.sidebarMobileActive
  }"
>
  <div class="layout-menu-wrapper">
    <i
      [ngClass]="{
        'pi-bars': (app.isDesktop() && !app.sidebarDesktopInactive) || (!app.isDesktop() && app.sidebarMobileActive),
        'pi-ellipsis-v':
          (app.isDesktop() && app.sidebarDesktopInactive) || (!app.isDesktop() && !app.sidebarMobileActive),
        'sidebar-desktop-inactive': app.sidebarDesktopInactive,
        'sidebar-mobile-active': app.sidebarMobileActive
      }"
      class="pi"
      data-cy="jml-menu-button"
      (click)="app.onMenuButtonClick($event)"
    ></i>

    <p-scrollPanel [style]="scrollPanelStyle" class="scrollPanelFix" (window:resize)="onResize()">
      <jml-menu data-cy="jml-menu"></jml-menu>
    </p-scrollPanel>
  </div>
</div>
